import { gql } from '@apollo/client';

export const LINK_PATIENT_WITH_PHARMACY = gql`
  mutation linkPatientWithPharmacy($data: CreatePharmacyInput!) {
    linkPatientWithPharmacy(data: $data)
  }
`;
